var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Gift card") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.84,5.8a1,1,0,0,1-.31.75,1.05,1.05,0,0,1-.74.31H1.06a1.06,1.06,0,0,1-.75-.31A1,1,0,0,1,0,5.8v-1A1,1,0,0,1,.31,4a1.06,1.06,0,0,1,.75-.31H4.32l-.56-.5a1.74,1.74,0,0,1-.58-1.27A1.83,1.83,0,0,1,5,0,1.78,1.78,0,0,1,6.27.49l1.4,1.32L9,.49A1.84,1.84,0,0,1,10.36,0a1.78,1.78,0,0,1,1.29.59,1.78,1.78,0,0,1,.49,1.32,1.77,1.77,0,0,1-.59,1.28l-.53.5h3.77a1.05,1.05,0,0,1,.74.31,1,1,0,0,1,.31.75Zm-9,2.12v7.92a30.36,30.36,0,0,1-5-.55,1.05,1.05,0,0,1-.61-.37,1,1,0,0,1-.24-.67V7.92ZM9,7.92h5.81v6.33a1,1,0,0,1-.24.67,1.08,1.08,0,0,1-.62.37A30.36,30.36,0,0,1,9,15.84Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabGift);
export default __webpack_public_path__ + "static/media/tab-gift.399bfcdc.svg";
export { ForwardRef as ReactComponent };